import { Component } from '@angular/core';

@Component({
  selector: 'default-catalog',
  templateUrl: './catalog.component.html',
  styleUrls: []
})
export class CatalogComponent {
}
